module.exports = __webpack_public_path__ + "img/pricing-card-underline.1975565b.svg";